module.exports = __webpack_public_path__ + "static/media/pdf.e268aa3f.jpg";